import CabinIcon from '@mui/icons-material/Cabin'
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import { DlspPermissionIcon } from '../../styled/DlspPermissionIcon';
import { hikoGeneratePath } from '@northpowerdev/np-react-utils';

const { ListItem, ListItemText, Typography, Box, Avatar, ListItemButton, ListItemAvatar, Stack } = require("@mui/material")
const { useNavigate, createSearchParams } = require("react-router-dom")
const { default: ICPNumberChip } = require("../../styled/ICPNumberChip")
const { default: WorkOrderDate } = require("../../styled/WorkOrderDate")
const { default: DlspTaskStatusChip } = require("../../styled/DlspTaskStatusChip")
const { default: styled } = require("@emotion/styled")

const StyledListItemButton = styled(ListItemButton)(({theme}) => {
    return ({
        [theme.breakpoints.down('md')]: {
          paddingLeft: '6px',
          paddingRight: '6px',
        },
        [theme.breakpoints.down('sm')]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
    })
})

const StyledListItemAvatar = styled(ListItemAvatar)(({theme}) => {
    return ({
        // minWidth: '8em',
    })
})

export function DlspTaskListItem({task, assignee}) {
    
    const navigate = useNavigate() // Might be inefficient if thousands of list items - if so, put in parent

    const handleViewDlspTask = (icpNumber) => {
        console.log('handleViewIcpInspection', icpNumber)
        const urlString = '/dlsp/task/details'
        const params = {icp_number: icpNumber}
        if (assignee) {
            params.assignee = assignee 
        }
        // const path = generatePath(":urlString?:queryString", { urlString, queryString: createSearchParams(params).toString() });
        const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
        navigate(path)
    }

    const premiseNotes = [];
    ['premiseType', 'addressNotes', 'decommissionReason'].forEach(p => {
        if (task[p]) {
            premiseNotes.push(task[p])
        }
    })
    const uniquePremiseNotes = [...new Set(premiseNotes)]

    return (
        <ListItem sx={{px: 0}}>
            <StyledListItemButton alignItems="flex-start" onClick={() => handleViewDlspTask(task.icp)}>
                <StyledListItemAvatar>
                    <Avatar alt={task.icp}><CabinIcon /></Avatar>
                </StyledListItemAvatar>
                <ListItemText
                    primary={
                    <>
                        <Typography variant="h6">
                            {task.address}
                        </Typography>
                        {
                            uniquePremiseNotes.length > 0
                            &&
                            <Typography variant="body2">{uniquePremiseNotes.join(', ')}</Typography>
                        }
                        <Typography variant="h6" sx={{mb:1}}>
                            <ICPNumberChip sx={{fontSize: '0.75em'}} icpNumber={task.icp} />
                        </Typography>
                        <Typography variant="body2">
                            <WorkOrderDate prefix='' isoDateString={task.decommissionDate} boldDate={true} />
                        </Typography>
                    </>
                    }
                />
                <Box sx={{mr: 4}}>
                {
                    task?.desktopQA?.landOwnerPermissionRequired === 'Yes'
                    &&
                    <Stack direction="column" alignItems="center">
                        <DlspPermissionIcon className={task?.landownerPermission?.permissionReceived} />
                        {
                            task?.landownerPermission?.permissionReceived !== 'Yes' 
                            &&
                            <Typography variant="body2" textAlign={"center"}>
                                Permission
                                <br />
                                Needed
                            </Typography>
                        }
                    </Stack>
                }
                </Box>
                <Box sx={{mr: 4}}>
                {
                    task.desktopInspTooHard
                    &&
                    <Stack direction="column" alignItems="center">
                        <ProductionQuantityLimitsIcon />
                        <Typography variant="body2" textAlign={"center"}>
                            Priority QA
                            <br />
                            Too Hard
                        </Typography>
                    </Stack>
                }
                </Box>
                <Box>
                    <DlspTaskStatusChip status={task.status} statusReason={task.assignee} />
                </Box>
            </StyledListItemButton>
        </ListItem>
    )
}
